import { Component, Input, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/providers/auth.service';

enum backToRoutes {
  merchant = '/merchant-management/list-merchant',
  transaction = '/transaction-management/transactions',
  parameter = '/steam-param/list-device',
  customers = '/customer-management/customers',
  agentOffice = '/customer-management/customers',
  myCustomer = '/consumer-list/list',
  tpnSnapshot = '/steam-param/tpn-snapshot',
  batches = 'batch-management/batches',
  editStore = 'merchant-management/merchant-create-management/edit-store',
  myApplications = '/dv-store/app-dashboard',
  multiMid = '/merchant-management/multi-mid',
  valueAddedList = '/dv-store/list-apps',
  merchantInvoicing ='/billing-invoice/m-b'
}

enum popoverText {
  merchant = 'Back ( Merchants )',
  transaction = 'Back ( Transaction )',
  parameter = 'Back ( Edit Parameters )',
  customers = 'Back ( Customers )',
  agentOffice = 'Back ( Agent Office )',
  myCustomer = 'Back ( My Customers )',
  tpnSnapshot = 'Back ( About Device )',
  batches = 'Back ( Batches )',
  editStore = 'Back ( Edit Store )',
  multiMid = 'Back ( Multi MID )',
  valueAddedList = 'Back ( Value-Added Apps )',
  merchantInvoicing ='Back ( Merchant Invoicing )'
}

const enableBackButtonRoutes = [
  'merchant',
  'transaction',
  'parameter',
  'customers',
  'agentOffice',
  'myCustomer',
  'tpnSnapshot',
  'batches',
  'editStore',
  'multiMid',
  'valueAddedList',
   'm-b-s',
   'merchantInvoicing',
]


@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {

  @Input() paramDest: string | null = null;
  isAgentOffice = false
  isParamDestEnabled: boolean = false
  tpnFromParam;
  public billingRote;
  param = { applyPreviousFilter: true, keepViewMode:true };

  constructor(private router: Router, private authService: AuthService, private route:ActivatedRoute) { }
  backbuttonPopoverText: string = 'Back to previous page';

  ngOnInit(): void {

    this.route.queryParams.subscribe(async (param) => {
      this.billingRote = param.from;
      if(param.sendTpnInReturnUrl){
        this.tpnFromParam = param?.tpn;
        this.param['tpn'] = param?.tpn;
      }
      if (param?.route == 'editStore') {
         this.param['id'] = param?.storeId;
         this.param['type'] = 'edit_store';
         this.param['btn'] = "1";
         this.param['gostep'] = '1';
      }
    });

    const user = this.authService.getUser
    if (user.userType == 'SUB_ISO' || user.userType == 'ISO') {
      this.isAgentOffice = true
    }
    if (this.isAgentOffice && this.paramDest == 'customers') { 
      this.paramDest = 'agentOffice'
    }
    if (this.paramDest) {
      this.backbuttonPopoverText = popoverText[this.paramDest]
      this.isParamDestEnabled = enableBackButtonRoutes.includes(this.paramDest)
    }
  }

  backToPreviousPage() {
    if (this.paramDest == 'multiMid' || this.paramDest == 'm-b-s') {
      if (this.paramDest == 'm-b-s' && !this.billingRote) {
        this.router.navigate(['/billing-invoice/m-b-s']);
        return;
      }
      window.history.back();
      return;
    }
    if (this.paramDest) {
      this.router.navigate([backToRoutes[this.paramDest]], { queryParams: this.param });
    }
  }

}
